import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { Settings, Settings2, Wrench } from "lucide-react";
import TabsComponent from "@/components/tabs/tabs-component";

export const Route = createFileRoute(
  "/plant-3/(processes-screens)/processes-management",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const location = useLocation();
  const activeTab = location.pathname;

  const tabs = [
    {
      icon: <Settings className="aero:h-5 aero:w-5" />,
      label: "Processes",
      direction: "/plant-3/processes-management/processes",
    },
    {
      icon: <Wrench className="aero:h-5 aero:w-5" />,
      label: "Part Processes",
      direction: "/plant-3/processes-management/part-processes",
    },
  ];

  return (
    <div className="aero:flex aero:flex-col aero:gap-4 aero:w-full aero:max-w-full aero:px-4 aero:overflow-hidden">
      <div className="aero:flex aero:flex-col aero:gap-4 aero:w-full aero:min-w-0">
        {/* Header with icon */}
        <div className="aero:flex aero:items-center aero:gap-3">
          <div className="aero:w-10 aero:h-10 aero:rounded-lg aero:bg-brand-primary-50 aero:flex aero:items-center aero:justify-center">
            <Settings2 className="aero:text-brand-primary-500 aero:h-6 aero:w-6" />
          </div>
          <div>
            <h1 className="aero:text-xl aero:md:text-2xl aero:text-foreground aero:font-bold aero:leading-9">
              Part - Process
            </h1>
            <p className="aero:text-xs aero:md:text-sm aero:text-neutral-500 aero:leading-5">
              Manage processes and part processes for Plant 3
            </p>
          </div>
        </div>

        {/* Tabs */}
        <TabsComponent tabs={tabs} activeTab={activeTab} />
      </div>

      {/* Render content */}
      <Outlet />
    </div>
  );
}
